import { cargaAssetsAlfombra } from "./assetsAlfombra";
import { cargaAssetsBolilla } from "./assetsBolilla";
import { cargaAssetsBotones } from "./assetsBotones";
import { cargaAssetsCarteles } from "./assetsCarteles";
import { cargaAssetsDisplayMonto } from "./assetsDisplayMonto";
import { cargaAssetsFichasAlfombra } from "./assetsFichasAlfombra";
import { cargaAssetsFichasEleccion } from "./assetsFichasEleccion";
import { cargaAssetsNumerosDisplay } from "./assetsNumerosDisplay";
import { cargaAssetsRuleta } from "./assetsRuleta";
import { cargaAssetsUltimosNumeros } from "./assetsUltimosNumeros";
import { cargaAssetsValoresAlfombra } from "./assetsValoresAlfombra";
import { cargaAssetsValoresGanadores } from "./assetsValoresGanadores";

/**
 * Carga todos los assets del juego de la ruleta
 * @param {*} scene 
 */
export function cargaAssetsPrincipal(scene) {

  cargaAssetsAlfombra(scene);
  cargaAssetsBolilla(scene);
  cargaAssetsBotones(scene);
  cargaAssetsCarteles(scene);
  cargaAssetsDisplayMonto(scene);
  cargaAssetsFichasAlfombra(scene);
  cargaAssetsFichasEleccion(scene);
  cargaAssetsNumerosDisplay(scene);
  cargaAssetsRuleta(scene);
  cargaAssetsUltimosNumeros(scene);
  cargaAssetsValoresAlfombra(scene);
  cargaAssetsValoresGanadores(scene);

}
